<template>
<div class="cents">
    <div class="barnva">
        <van-nav-bar
        :title="this.$t('xzgjhdq')"
        left-text=""
        left-arrow
        
        @click-left="onClickLeft"
        />
    </div>
    <van-index-bar :index-list="indexList" highlight-color="#000" >

         <van-index-anchor :index="this.$t('rmcs')">{{this.$t('rmcs')}}</van-index-anchor>
            <van-cell :title="item.city"  v-for="(item,index) in list" :key="index"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>

        <van-index-anchor index="A">A</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list2" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>

        <van-index-anchor index="B">B</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list3" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="C">C</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list4" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="D">D</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list5" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="E">E</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list6" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="F">F</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list7" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="G">G</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list8" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="H">H</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list9" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="J">J</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list10" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="K">K</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list11" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
                
            </van-cell>
        <van-index-anchor index="L">L</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list12" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="M">M</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list13" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="N">N</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list14" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
         <van-index-anchor index="P">P</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list15" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="R">R</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list16" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="S">S</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list17" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="T">T</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list18" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="W">W</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list19" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="X">X</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list20" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="Y">Y</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list21" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
        <van-index-anchor index="Z">Z</van-index-anchor>
            <van-cell :title="item.city"  v-for="item in list22" :key="item.code"  @click="ss(item.code)">
                {{item.code}}
            </van-cell>
    </van-index-bar>
</div>
</template>
<script>
export default {
    data(){
        return{
            indexList:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','P',
            'Q','R','S','T','U','V','W','X','Y','Z'],
            list:[
                {
                    "city": this.$t('zgdl'),
                    "code": "+86"
                },
                {
                    "city": this.$t('zgxg'),
                    "code": "+852"
                },
                {
                    "city": this.$t('zgam'),
                    "code": "+853"
                },
                {
                    "city": this.$t('zgtw'),
                    "code": "+886"
                },
            ],
            list2:[
                {
                "city": this.$t('afh'),
                "code": "+93"
                },
                {
                    "city": this.$t('ade'),
                    "code": "+376"
                },
               
                {
                    "city": this.$t('agt'),
                    "code": "+54"
                },
                {
                    "city": this.$t('ymny'),
                    "code": "+374"
                },
                {
                    "city": this.$t('alb'),
                    "code": "+297"
                },
                {
                    "city": this.$t('adl'),
                    "code": "+43"
                },
                {
                    "city": this.$t('asbj'),
                    "code": "+994"
                },
            ],
            list3:[
                {
                    "city": this.$t('bhm'),
                    "code": "+1242"
                },
                {
                    "city": this.$t('bl'),
                    "code": "+973"
                },
                
                {
                    "city": this.$t('bbds'),
                    "code": "+1246"
                },
                {
                    "city": this.$t('bels'),
                    "code": "+375"
                },
				{
				    "city": this.$t('bx'),
				    "code": "+55"
				},
                {
                    "city": this.$t('bls'),
                    "code": "+32"
                },
                {
                    "city": this.$t('bjst'),
                    "code": "+92"
                },
				

            ],
            list4:[
                {
                    "city": this.$t('cxx'),
                    "code": "+850"
                },
                {
                    "city": this.$t('cdjny'),
                    "code": "+240"
                },
            ],
            list5:[
                {
                    "city": this.$t('dg'),
                    "code": "+49"
                },
                {
                    "city": this.$t('dm'),
                    "code": "+45"
                },
                {
                    "city": this.$t('jbt'),
                    "code": "+253"
                },
                {
                    "city": this.$t('dmnjghg'),
                    "code": "+1890"
                },
            ],
            list6:[	
                {
                    "city": this.$t('els'),
                    "code": "+7"
                },
                {
                    "city": this.$t('egde'),
                    "code": "+593"
                },
                {
                    "city": this.$t('aj'),
                    "code": "+20"
                },
                {
                    "city": this.$t('aseby'),
                    "code": "+251"
                },
            ],
            list7:[	
                {
                    "city": this.$t('fg'),
                    "code": "+33"
                },
                {
                    "city": this.$t('fl'),
                    "code": "+358"
                },
                {
                    "city": this.$t('flb'),
                    "code": "+63"
                },
                {
                    "city": this.$t('fdg'),
                    "code": "+379"
                },
            ],
            list8:[	
                {
                    "city": this.$t('gby'),
                    "code": "+220"
                },
                {
                    "city": this.$t('ggghg'),
                    "code": "+242"
                },
                {
                    "city": this.$t('glby'),
                    "code": "+57"
                },
                {
                    "city": this.$t('gb'),
                    "code": "+53"
                },
            ],
            list9:[	
                {
                    "city": this.$t('hg'),
                    "code": "+82"
                },
                {
                    "city": this.$t('hl'),
                    "code": "+31"
                },
                
                {
                    "city": this.$t('hd'),
                    "code": "+509"
                },
            ],
            list10:[	
               
                {
                    "city": this.$t('jbz'),
                    "code": "+855"
                },
                {
                    "city": this.$t('jlbs'),
                    "code": "+686"
                },
                {
                    "city": this.$t('jny'),
                    "code": "+224"
                },
                {
                    "city": this.$t('jbbw'),
                    "code": "+263"
                },
            ],
            list11:[	
                {
                    "city": this.$t('kml'),
                    "code": "+237"
                },
                {
                    "city": this.$t('kmqt'),
                    "code": "+1345"
                },
                {
                    "city": this.$t('kny'),
                    "code": "+254"
                },
                {
                    "city": this.$t('kwt'),
                    "code": "+965"
                },
                {
                    "city": this.$t('kldy'),
                    "code": "+385"
                },
            ],
            list12:[	
                
                {
                    "city": this.$t('lys'),
                    "code": "+856"
                },
                {
                    "city": this.$t('lby'),
                    "code": "+218"
                },
                {
                    "city": this.$t('lwd'),
                    "code": "+250"
                },
            ],
            list13:[	
                {
                    "city": this.$t('mg'),
                    "code": "+1"
                },
                {
                    "city": this.$t('mlxy'),
                    "code": "+60"
                },
                
                {
                    "city": this.$t('mxg'),
                    "code": "+52"
                },
            ],
            list14:[	
                {
                    "city": this.$t('nf'),
                    "code": "+27"
                },
                {
                    "city": this.$t('nbe'),
                    "code": "+977"
                },
                {
                    "city": this.$t('nrly'),
                    "code": "+234"
                },
                {
                    "city": this.$t('nw'),
                    "code": "+47"
                },
            ],
            list15:[	
                {
                    "city": this.$t('plqd'),
                    "code": "+680"
                },
                {
                    "city": this.$t('pty'),
                    "code": "+351"
                },
            ],
            list16:[	
                {
                    "city": this.$t('rb'),
                    "code": "+81"
                },
                {
                    "city": this.$t('rd'),
                    "code": "+46"
                },
                {
                    "city": this.$t('rs'),
                    "code": "+41"
                },
            ],
            list17:[	
                
                {
                    "city": this.$t('stalb'),
                    "code": "+966"
                },
                {
                    "city": this.$t('sd'),
                    "code": "+249"
                },
                {
                    "city": this.$t('slxy'),
                    "code": "+1758"
                },
            ],
            list18:[	
                {
                    "city": this.$t('tgs'),
                    "code": "+66"
                },
                {
                    "city": this.$t('tjs'),
                    "code": "+676"
                },
                {
                    "city": this.$t('teq'),
                    "code": "+90"
                },
            ],
            
            list19:[	
                {
                    "city": this.$t('wnrl'),
                    "code": "+58"
                },
                {
                    "city": this.$t('wl'),
                    "code": "+673"
                },
                {
                    "city": this.$t('wkl'),
                    "code": "+380"
                },
            ],
            list20:[	
                {
                    "city":this.$t('xxl'),
                    "code": "+64"
                },
                {
                    "city": this.$t('xjb'),
                    "code": "+65"
                },
                {
                    "city": this.$t('xby'),
                    "code": "+34"
                },
                {
                    "city": this.$t('xl'),
                    "code": "+30"
                },
                {
                    "city": this.$t('xyl'),
                    "code": "+36"
                },
            ],
            list21:[	
                {
                    "city": this.$t('ydl'),
                    "code": "+39"
                },
                {
                    "city": this.$t('yg'),
                    "code": "+44"
                },
                {
                    "city": this.$t('ydnxy'),
                    "code": "+62"
                },
                {
                    "city": this.$t('yd'),
                    "code": "+91"
                },
                {
                    "city": this.$t('yn'),
                    "code": "+84"
                },
                {
                    "city": this.$t('ylk'),
                    "code": "+964"
                },
            ],
            list22:[	
                {
                    "city": this.$t('zl'),
                    "code": "+56"
                },
                {
                    "city": this.$t('zfghg'),
                    "code": "+236"
                },
            ],
            
        }
    },
    methods:{
        ss(v){
        //    this.$router.push({path:'/login',query:{value:v}})
           localStorage.setItem('address', v)
           this.$router.go(-1)
        //    this.$parent.address = v
        },
        onClickLeft(){
            this.$router.go(-1) 
        }
    }
}
</script>
<style scoped>
.cents >>>.van-index-anchor{
    text-align: left;
    font-weight: bold;
    background-color: #ccc;
}
.cents >>>.van-cell__title{
    text-align: left;
}
.cents >>>.van-cell__value{
    text-align: center;
}
/* .cents .barnva{
    width: 100%;
    height: 46px;
    position: fixed;
    top: 0;
} */
</style>